document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('ElemitalSlider');
  const prevBtn = document.querySelector('.prev-btn');
  const nextBtn = document.querySelector('.next-btn');

  // 1. Chức năng bấm nút trượt ngang (Giữ nguyên)
  if(slider && prevBtn && nextBtn) {
    nextBtn.addEventListener('click', () => {
      slider.scrollBy({ left: window.innerWidth, behavior: 'smooth' });
    });

    prevBtn.addEventListener('click', () => {
      slider.scrollBy({ left: -window.innerWidth, behavior: 'smooth' });
    });
  }

  // 2. Chức năng Animation: Quan sát Slide trên màn hình
  const slides = document.querySelectorAll('.single-slide');
  
  // Cài đặt 'camera' theo dõi: Kích hoạt khi slide ló ra được 50% màn hình
  const observerOptions = {
    root: slider,
    threshold: 0.5 
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Nếu slide đang nằm giữa màn hình -> Thêm class is-active
        entry.target.classList.add('is-active');
      } else {
        // Nếu slide bị trượt qua -> Gỡ class đi để lần sau quay lại nó vẫn chớp animation
        entry.target.classList.remove('is-active');
      }
    });
  }, observerOptions);

  // Gắn 'camera' vào tất cả các slide
  if(slides.length > 0) {
    slides.forEach(slide => observer.observe(slide));
  }
});